import React, { useState, useEffect } from 'react'
import { Row, Col, Form, Button } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { SurveyForm } from '../types/index'
import { saveAnswerAPI } from '../api/surveyAPI';
import { useTranslation } from "react-i18next";
export default function SurveyFormTextArea({ surveyItem, idPerson, reloadSurvey }: SurveyForm) {
    const { t } = useTranslation();
    const [idAnswer, setIdAnswer] = useState<number>(Number(surveyItem.answers[0].id));
    const [value, setValue] = useState<string>('');

    const navigate = useNavigate();

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const body = {
            IdSurvey: surveyItem.idSurvey,
            IdPerson: idPerson,
            IdQuestion: surveyItem.question.id,
            IdAnswer: idAnswer,
            Value: value,
            Order: surveyItem.question.order,
        }

        try {
            const result = saveAnswerAPI(body);
        } catch (error) {
            console.error(error);

        } finally {
            const order = surveyItem.question.order + 1;
            if (order > surveyItem.numQuestions) {
                navigate("/end-survey/" + surveyItem.idSurvey + "/" + order);
            } else {
                navigate("/survey/" + surveyItem.idSurvey + "/" + order);
                reloadSurvey(Number(order));
            } 
        }
    };

    const handlback = () => {
        if (surveyItem.question.order === 1) {
            navigate("/pending-surveys");
        } else {
            const order = surveyItem.question.order - 1;
            navigate("/survey/" + surveyItem.idSurvey + "/" + order);
            reloadSurvey(Number(order));
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (surveyItem !== null && surveyItem.answerValue != null) {
                    setIdAnswer(surveyItem.answerValue.idAnswer);
                    setValue(surveyItem.answerValue.value);
                }

            } catch (error) {
                console.error(error);

            } finally {
                console.log("loaded");
            }
        }

        fetchData()
    }, [])

    return (
        <>
            <Form onSubmit={handleSubmit}>

                <Row>
                    <Form.Group>
                        <Form.Label className="d-flex question" >{surveyItem !== null ? surveyItem.question.order + ".- " + surveyItem.question.description : ""} </Form.Label>
                        <Form.Control value={value} as="textarea" rows={3} readOnly={surveyItem.dataAnswer !== null}  onChange={(e) => setValue(e.target.value)}></Form.Control>
                    </Form.Group>
                </Row>
                <Row className="btns-margin">
                    <Col xs={3} md={3}>
                        <Button variant="light" className="btn btn-outline-secondary w-100" onClick={handlback}>
                            <img
                                src="/back.svg"
                                alt="back"
                                style={{ width: '20px' }}
                            />
                        </Button>
                    </Col>
                    <Col xs={9} md={9}>
                        <Button variant="success" className="w-100" type="submit">
                            {t("surveyPendingQuestionButtonNext")}
                        </Button>
                    </Col>
                </Row>
            </Form>
        </>
               
    );
}